import React from "react";
import "@Styles/mandate.css";
import "react-confirm-alert/src/react-confirm-alert.css";
import Loader_rocket from "@Images/NewUI/loader_rocket.gif";
import { HEADING_NBFCASSIGNED } from "../Common/constant";
import CountDown from "../Common/CountDown";
import arrowleft from "@Images/NewUI/Vector.png";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { nbfcDetails } from "../../../Redux/ApplyLoan/action";
import moment from "moment";
import { useState, useEffect } from "react";

const NbfcAssignedmessage = (props) => {
  const navigate = useNavigate();
    const token = props?.user?.User?.token || localStorage.getItem("gpay_token");

  const [show, setShow] = useState(false);
  const [nbfc_detail, setNbfcDetails] = useState("");
  const [loader, setLoader] = useState(true);
  const [waitloader, setWaitloader] = useState(false);
  const [isButtonDisabled, setIsButtonDisbled] = useState(false);

  useEffect(() => {
    let now = moment();
   
    props.nbfcDetails(token)
      .then((res) => {
        setLoader(false);
        if (res.data.data.loan_status === "DISBURSED") {
          disbursedSuccess(res.data.data.disbursal_amount);
        }

        setNbfcDetails(res.data.data);

        // console.log("MMMMMMMMMMMMMMMM", res.data.data);
      })

      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
         window.location.href = "/";
          localStorage.removeItem("gpay_token");
        }
       
       
        // console.log(err);
      });
  }, []);
  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);

  const disbursedSuccess = (amount) => {
    navigate("/disburse_success", { state: { amount: amount } });
  };
  const enableCustomerSupport = () => {
    setIsButtonDisbled(true);
  };
  
    let usrMsg = JSON.parse(new URLSearchParams(window.location.search).get("details"));
    return (
      <div className="container">
        <div className="">
         <div style={{height:20}}></div>
          {/* <img  className="nbfcheading" style={{cursor:"pointer"}}  src={arrowleft} onClick={() => {
          window.location.href="/nbfc_assigned"; 
      }} /> */}
       <h1 className="boldheading" style={{ paddingLeft:"27px", color:'#152745', fontWeight:'800', fontSize:'25px'}}>{HEADING_NBFCASSIGNED}</h1>
          

          <div className="wrapper-content mb-5">
            <div className=" rounded-20 px-4 pb-3 pt-1 w-100 text-center mx-auto bg-gray rounded-40 shadow-lg" >
              <div className="styled h-100 d-flex flex-column ">
                <div className="pt-5">
                  <img
                    src={Loader_rocket}
                    style={{ width: 220, height: 220 }}
                    alt="PaymeIndia"
                  />
                </div>
                <h1 className="h1">{usrMsg?.heading}</h1>
                <h4>{usrMsg?.subHeading}</h4>
                <p className="msg boldtext">Please wait until the<br/>
disbursal period before <br/>contacting support</p>

            <p>Disbursed in 24 hours</p>
            
            <CountDown
                        tenure_date={nbfc_detail?.tenure_date}
                        enableCustomerSupport={enableCustomerSupport}
                      />
            
              </div>
            </div>
          </div>
        </div>
        <div className="text-center bottombtndiv pt-4">

            <div className="arrownbfc">
                <img style={{cursor:"pointer"}}  src={arrowleft} 
                onClick={() => {
                    window.location.href="/nbfc_assigned";}} />
            </div>
            <button
              className="NbfcBtntext blur"
              onClick={() => {
                navigate("/nbfc_message");
              }}
              disabled={!isButtonDisabled}
            >
            
              Contact Support
            </button>
        </div>
      </div>
    );
  }

  const mapStateToProps = (state) => {
    return {
      user: state.user,
    };
  };
  
  export default connect(mapStateToProps, { nbfcDetails })(NbfcAssignedmessage);
